import { render } from "./ProductManageActions.vue?vue&type=template&id=268e8498&ts=true"
import script from "./ProductManageActions.vue?vue&type=script&lang=ts"
export * from "./ProductManageActions.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__